import {apiClient} from '../client'
import handleError from '../../utilities/api-helpers/handleError'

export const fetchBuildingBedroomRanges = async () => {
  const {building_bedroom_ranges, meta: {total}} = await apiClient.get('building_bedroom_ranges').catch(handleError)
  return {building_bedroom_ranges, total}
}